<template>
  <div>
    <vs-popup class="edit-role-popup" title="" :active.sync="editRoleModalActive">
    <div class="vx-row flex-wrap title-bar">
        <h3>Edit Role Details</h3>
      </div>

      <hr>

      <div class="vx-row flex-wrap justify-start px-5">
        <div class="vx-col sm:w-1/4 w-1/4 mb-2">
          <h5 class="mt-5">Role Details</h5>
        </div>
      </div>

      <div class="vx-row flex-wrap justify-start px-5 mt-3">
        <div class="vx-col md:w-1/2 w-1/2 mb-2">
          <label class="vs-input--label inline-flex pb-2">User Role</label>
          <vs-input
          name="Role"
          class="w-full role"
          v-model="roleDetails.role"
          disabled/>
        </div>

        <div class="vx-col md:w-full w-full mb-2">
          <label class="vs-input--label inline-flex pb-2">Modules/Permission</label>          
          <treeselect
          name="Role Permissions"
          v-if="roleDetails.role"
          class="w-full"
          :multiple="true"
          :options="modulesForRole"
          :sort-value-by="sortValueBy"
          :clearable="true"
          placeholder=""
          :default-expand-level="1"
          v-model="roleDetails.modulePermissions" >

          <div v-if="node.raw.permission_name" slot="value-label" slot-scope="{ node }"> {{ node.raw.permission_name.split('.')[0].split('_').join(' ') | toTitleCase }} : {{ node.raw.label }}</div>
          <div v-else slot="value-label" slot-scope="{ node }"> {{ node.raw.label }} : All Permissions</div>

          </treeselect>
          <span class="text-danger text-sm" v-show="errors.has('Registrar')">This field is required</span>
        </div>
      </div>

      <hr class="mt-12">

      <div class="vx-row flex justify-end">
        <div class="vx-col mt-8 mb-3">
          <vs-button name="submit" id="button-with-loading" color="primary" type="filled" class="custom-btn ml-auto mb-4" @click="submit()" icon-after>Save</vs-button>
        </div>
      </div>
    </vs-popup>

    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
			<div class="con-content" slot="content">
        <p v-if="customPromptMessage">{{ customPromptMessage }}</p>
				<p v-else-if="customPromptError">{{ customPromptError }}</p>
      </div>
    </custom-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Treeselect from "@riophae/vue-treeselect";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
  name: 'EditRole',
  components: {
    'v-select': vSelect,
    Treeselect,
    CustomPrompt
  },
  data() {
    return {
      editRoleModalActive: false,
      roleDetails: {
        id: null,
        role: null,
        modulePermissions: []
      },
      modulesForRole: [],
      sortValueBy: 'ORDER_SELECTED',
      // Custom Dialog props
      customPrompt: {
        activePrompt: false,
        title: '',
        buttonText: '',
        type: '',
        color: '',
        classList: '',
        accept: null
      },
      customPromptMessage: null,
      customPromptError: null
    }
  },
  mounted() {
    this.$root.$on('openEditRoleModal', (rowData) => {
      this.roleDetails['id'] = rowData.data.id;
      this.roleDetails['role'] = this.toTitleCase(rowData.data.name.split('.')[0].split('_').join(' '));
      this.fetchModulesForRole();
      this.editRoleModalActive = true;
    })
  },
  computed: {
    fetchRoles() {
      return this.$store.getters.getRoles;
    },
    setPermissionsPayload() {
      let tempModulesForRole = this.modulesForRole.slice(0);
      let permissionId = [];

      this.roleDetails.modulePermissions.map(x => {
        if(typeof x == 'string') {
          let children = tempModulesForRole.find(y => x == y.id).children;
          children.map(z => {
            permissionId.push(z.id);
          })
        } else {
            permissionId.push(x);
        }
      })

      return permissionId;
    }
  },
  watch: {
    fetchRoles() {
      return this.$store.getters.getRoles;
    },
  },
  methods: {
    // NOTE: CTA
    submit() {
      let payload = { permission_id: this.setPermissionsPayload };

      this.$axiosSecure.post(`/permissions/${this.roleDetails.id}`, payload)
      .then((response) => {
        // this.customPromptMessage = response.data.message;
        this.customPromptMessage = 'Role permissions updated successfully!';

        if(response.data.type == 'Success') {
					this.isAccessCodeSent = true;

					this.customPrompt['activePrompt'] = true;
					this.customPrompt['title'] = 'Success!';
					this.customPrompt['acceptText'] = 'Okay';
					this.customPrompt['color'] = 'primary'
				}

        this.editRoleModalActive = false;
        this.$root.$emit('refreshRoleList');
      })
      .catch((error) => {
        this.customPromptError = error.response.data.message;

				this.customPrompt['activePrompt'] = true;
				this.customPrompt['type'] = 'error';
				this.customPrompt['title'] = 'Error';
				this.customPrompt['acceptText'] = 'Okay';
				this.customPrompt['color'] = 'danger';
				this.customPrompt['classList'] = 'danger-prompt';
      })
    },
    fetchModulesForRole() {
      if(this.roleDetails && this.roleDetails.id) {
        this.$axiosSecure.get(`/permissions/${this.roleDetails['id']}`)
        .then((response) => {
          this.modulesForRole = response.data;
          this.roleDetails['modulePermissions'] = [];
          this.modulesForRole.map(x => {
            let children = x.children.slice();
            let selectedChildren = children.filter(y => y.isSelected);

            if(children.length == selectedChildren.length) {
              this.roleDetails['modulePermissions'].push(x.id);
            } else {
              this.roleDetails['modulePermissions'].push(...selectedChildren.map(z => z.id));
            }
          })
        })
        .catch((error) => {
          // Error notification
          this.$vs.notify({
            color: 'danger',
            title: 'Something went wrong',
            text: 'Please contact the server admin',
          });
        })
      } else {
        this.modulesForRole = [];
      }
    },
  },
  destroyed() {
    this.$root.$off('openEditRoleModal');
  }
}
</script>